import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '../../../utilities/helperUtility';
import './index.css';

export default class RatesTableComponent extends Component {
  buildInputCounter(list, index) {
    const props = this.props.extraColumns[0],
          rateKey = this.props.columns.headers[1],
          item = this.props.items[list.key],
          quantity = item ? item.quantity : 0,
          attr = props.attrs[list.key],
          { max = null } = attr,
          { title, body, errorText } = this.props.style,
          { translation } = this.props,
          unavailable = max < quantity,
          nextValue = quantity + 1,
          prevValue = quantity - 1 > 0 ? quantity - 1 : 0;

    let name = `${list.key}_${props.header}`;

    if (translation.key('columnQuantity') == props.header) name = `${list.key}_quantity`;

    return (
      <React.Fragment key={`fragment-${list.key + index}`}>
        <tr key={list.key + index}>
          <td> {list[rateKey]} </td>
          <td className="counter">
            <div className="form-row">
              <div className="form-row__content">
                <button className="qtyminus" style={{...title}} onClick={() => props.onChange({target: {name: name, value: prevValue}})}>-</button>
                <input
                  {...attr}
                  name={name}
                  disabled={true}
                  className="qty"
                  type="text"
                  style={{
                    ...title,
                    backgroundColor: body.backgroundColor,
                    color: unavailable ? errorText.color : title.color,
                  }}
                  onInput={props.onChange.bind(this)}
                  value={quantity}
                />
                <button className="qtyplus" style={{...title}} onClick={() => props.onChange({target: {name: name, value: nextValue}})}>+</button>
              </div>
            </div>
          </td>
          <td> {list[translation.key('columnPrice')]} </td>
        </tr>
        {unavailable &&
        (<tr key={`${list.key + index}-error`}>
          <td colSpan="3" style={{ textAlign: 'center', padding: 0 }}>
            <p style={{ color: errorText.color, margin: 0 }}>{this.props.limitedSpacesMessage || "Sorry, limited spaces available"}</p>
          </td>
        </tr>)}
      </React.Fragment>
    )
  }

  render() {
    const { columns: { lists } } = this.props;

    return (
      <section>
        <div className="rates-table-container">
          <table className={"pure-table pure-form center fluid"}>
            <tbody>
              {lists.map((list, i ) => {
                return this.buildInputCounter(list, i);
              })}
            </tbody>
          </table>
        </div>
      </section>
    );
  }
}

RatesTableComponent.propTypes = {
  columns: PropTypes.shape({
    headers: PropTypes.array.isRequired,
    lists: PropTypes.array.isRequired,
  }),
  extraColumns: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string,
      type: PropTypes.string.isRequired,
      onChange: PropTypes.func,
    }),
  ),
};
